"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var GetLessonContentByEnv = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetLessonContentByEnv($uuid: ID!, $environment: EnvironmentInput!) {\n    getLessonContentByEnv(uuid: $uuid, environment: $environment) {\n      signedUrl\n      displayName\n      content\n    }\n  }\n"], ["\n  query GetLessonContentByEnv($uuid: ID!, $environment: EnvironmentInput!) {\n    getLessonContentByEnv(uuid: $uuid, environment: $environment) {\n      signedUrl\n      displayName\n      content\n    }\n  }\n"])));
exports.default = GetLessonContentByEnv;
var templateObject_1;
